import { Group, Stack } from '@mantine/core';
import { AttributeRow } from '../atoms/AttributesRow';

type AttributesProps = {
  rows: {
    label: string;
    value: string;
  }[];
};

export const Attributes = ({ rows }: AttributesProps) => {
  return (
    <Group grow>
      <Stack justify='space-between' align='center' gap='4'>
        {rows.slice(0, 4).map((row) => (
          <AttributeRow key={row.label} label={row.label} value={row.value} />
        ))}
      </Stack>
      <Stack justify='space-between' align='center' gap='4'>
        {rows.slice(4).map((row) => (
          <AttributeRow key={row.label} label={row.label} value={row.value} />
        ))}
      </Stack>
    </Group>
  );
};
